import * as React from "react";
import {RouteComponentProps} from "react-router-dom";
import {getKycRoute} from "Kyc/route";
import "./styles.scss";

const KycIndex = (props: RouteComponentProps) => {
    return (
        <div className="kyc-doc-options">
            {getKycRoute(props.match.path)}
        </div>
    );
};

export default KycIndex;
